/**
 * Como o painel escreve um local: "filial · depósito".
 *
 * Não existe endereço físico — o local de uma operação é o par (codFil, codDep)
 * do Senior. O mesmo `ALM01` pode existir em duas filiais, então o código do
 * depósito sozinho não identifica nada; toda tela escreve os dois juntos, nesta
 * ordem e com este separador, para a leitura não mudar de uma tela para outra.
 */

const SEPARADOR = ' · ';

/** Filial por extenso: `Filial 1`. */
export function rotuloDaFilial(codFil: number): string {
  return `Filial ${String(codFil)}`;
}

/**
 * `Filial 1 · ALM01`. Sem depósito, `—`. Sem filial (coleta que não resolveu
 * a filial), só o depósito — inventar a filial seria afirmar onde o produto
 * está sem saber.
 */
export function rotuloDoLocal(
  codFil: number | null | undefined,
  deposito: string | null | undefined,
  vazio = '—',
): string {
  if (deposito === null || deposito === undefined || deposito === '') {
    return vazio;
  }

  if (codFil === null || codFil === undefined) {
    return deposito;
  }

  return `${rotuloDaFilial(codFil)}${SEPARADOR}${deposito}`;
}

/**
 * Lê o que a pessoa digitou no filtro de filial.
 *
 * Só inteiro positivo vira recorte; o resto (vazio, letra, zero) é "sem
 * filtro" — mandar `codFil=abc` só renderia um 400 no lugar da lista.
 */
export function filialDoFiltro(texto: string): number | null {
  const limpo = texto.trim();

  if (!/^\d{1,5}$/.test(limpo)) {
    return null;
  }

  const numero = Number(limpo);
  return numero > 0 ? numero : null;
}
